import { jsx as _jsx } from "react/jsx-runtime";
export default function Icon(props) {
    var icon = props.icon, title = props.title, _a = props.role, role = _a === void 0 ? "button" : _a;
    return _jsx("i", { className: "ico ".concat(icon), title: title, "aria-label": title, role: role });
}
